"use strict";
/// <reference path="./Checklist.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveChecklistObject = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
const Utilities_1 = require("../../javascript/Utilities");
const ChecklistControls_1 = require("./ChecklistControls");
const ChecklistDesigner_1 = require("./ChecklistDesigner");
const ModificationInfo_1 = require("../../model/ModificationInfo");
class SaveChecklistObject {
    constructor() {
        this.success = (currentInstance) => { };
        this.fail = () => { };
        this.cleanUp = () => { };
    }
}
exports.SaveChecklistObject = SaveChecklistObject;
(($) => {
    let methods = {
        init(options) {
            return this.each(function () {
                let $this = $(this);
                let synData = $this.data('synChecklist');
                if (!synData) {
                    if (!$this.attr("id"))
                        $this.attr("id", Utilities_1.synUtil.getGUID(true));
                    $this.data('synChecklist', $.extend({
                        propertypageControlsWsUrl: Utilities_1.synUtil.getWSUrl("PropertypageControls"),
                    }, options));
                    $this.trigger("beginInit");
                    $this.addClass("synChecklist");
                    $this.trigger("endInit");
                }
            });
        },
        destroy() {
            return this.each(function () {
                let $this = $(this);
                let synData = $this.data('synChecklist');
                if (synData && synData.controls) {
                    $.each(synData.controls.allControls, function (index, control) {
                        control.destroy();
                    });
                }
                $(this).off("beginInit");
                $(this).off("endInit");
                $this.html("");
                $this.removeData('synChecklist');
            });
        },
        getInstance() {
            let $this = $(this);
            let synData = $this.data('synChecklist');
            if (!synData)
                return undefined;
            let fac = synData.controlFactory;
            if (!fac)
                return undefined;
            return fac.getInstance();
        },
        setInstance(checklist, configData, mode = ChecklistControls_1.ChecklistMode.Editor, readonly = false, action = ChecklistControls_1.ChecklistAction.Edit) {
            let $this = $(this);
            InitControls($this, checklist, configData, mode, readonly, action);
        },
        getDesignerInstance() {
            let $this = $(this);
            let synData = $this.data('synChecklist');
            if (!synData)
                return undefined;
            let designer = synData.checklistDesigner;
            if (!designer)
                return undefined;
            return designer.getChecklist();
        },
        selectNext(configData) {
            let $this = $(this);
            let synData = $this.data('synChecklist');
            if (!synData)
                return undefined;
            let fac = synData.controlFactory;
            if (!fac)
                return undefined;
            return fac.selectQuestion(true, configData);
        },
        selectPrevious(configData) {
            let $this = $(this);
            let synData = $this.data('synChecklist');
            if (!synData)
                return undefined;
            let fac = synData.controlFactory;
            if (!fac)
                return undefined;
            return fac.selectQuestion(false, configData);
        },
        showResult(result) {
            let $this = $(this);
            let synData = $this.data('synChecklist');
            if (!synData)
                return undefined;
            let fac = synData.controlFactory;
            if (!fac)
                return undefined;
            return fac.showResult(result);
        },
        showDesigner(configData, checklist, mode = ChecklistControls_1.ChecklistMode.Designer, window, calledFromFatClient = false) {
            let $this = $(this);
            ShowDesigner($this, configData, checklist, mode, window, calledFromFatClient);
        },
        updateTemplateInfo(templateInfo) {
            let $this = $(this);
            let synData = $this.data('synChecklist');
            if (!synData)
                return undefined;
            let designer = synData.checklistDesigner;
            if (!designer)
                return undefined;
            return designer.updateTemplateInfo(templateInfo);
        },
        close(instId, callback) {
            let changed = true;
            let checklistInstance;
            let $this = $(this);
            let synData = $this.data('synChecklist');
            if (synData) {
                let fac = synData.controlFactory;
                if (!fac || (fac.Mode & ChecklistControls_1.ChecklistMode.Designer)) {
                    let designer = synData.checklistDesigner;
                    if (designer)
                        checklistInstance = designer.getChecklist(false);
                }
                else
                    checklistInstance = fac.getInstance();
                if (checklistInstance) {
                    if (checklistInstance["changed"])
                        changed = checklistInstance["changed"];
                    else
                        changed = false;
                }
            }
            let close = true;
            if (changed)
                close = window.confirm(Utilities_1.synUtil.Strings.getValue("askclosechecklisteditor"));
            if (close) {
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("InstanceUndoCheckOut") + instId,
                    cleanUp() {
                        callback(true);
                    }
                });
            }
            else
                callback(false);
        },
        save(buttonId, close, instId, configData, typeId, saveObject) {
            saveObject = $.extend(true, new SaveChecklistObject(), saveObject);
            let checklistInstance;
            let designer;
            let $this = $(this);
            let synData = $this.data('synChecklist');
            if (!synData)
                return undefined;
            let fac = synData.controlFactory;
            return this.each(function () {
                if (!fac || (fac.Mode & ChecklistControls_1.ChecklistMode.Designer)) {
                    designer = synData.checklistDesigner;
                    if (!designer)
                        return undefined;
                    checklistInstance = designer.getChecklist();
                }
                else
                    checklistInstance = fac.getInstance();
                if ((fac && !fac.CheckValues()) || (designer && designer.clControlFactory && !designer.clControlFactory.CheckValues()))
                    return undefined;
                if (!checklistInstance)
                    return undefined;
                $this.trigger("controlLogFullLicense");
                let changed = true;
                // if(checklistInstance["changed"])
                //     changed = checklistInstance["changed"];
                let saveCallback = function (data) {
                    if (designer)
                        designer.clControlFactory.setChecklistChanged(false);
                    else
                        fac.setChecklistChanged(false);
                    if (close) {
                        if (typeof window.synDesktopApp !== "undefined")
                            window.synDesktopApp.endDialog("0");
                        else {
                            $("#" + configData.windowID).data("kendoWindow").close();
                            Utilities_1.synUtil.getInstance(instId, function (instance) {
                                let modificationInfo = new ModificationInfo_1.ModificationInfo();
                                modificationInfo.modifiedInstances = [instance];
                                $(window).trigger("forceRefreshSelectedView", modificationInfo);
                                let preview = $("#contentPane").find("#Preview");
                                if (preview && preview.data("synPreview"))
                                    preview.synPreview("recreateAsync");
                            });
                        }
                    }
                    else {
                        if (designer) {
                            if (changed) {
                                designer.updateTemplateInfo(data);
                                designer.clControlFactory.setSavedInstance(data);
                            }
                        }
                        else if (fac) {
                            if (changed) {
                                fac.setSavedInstance(data);
                                fac.Action = ChecklistControls_1.ChecklistAction.Edit; // relevant for acquisition
                            }
                        }
                    }
                    saveObject === null || saveObject === void 0 ? void 0 : saveObject.success(data);
                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                };
                if (changed) {
                    let action = ChecklistControls_1.ChecklistAction.Edit;
                    if (fac)
                        action = fac.Action;
                    let checklistInstanceUrl = Utilities_1.synUtil.getWSUrl("ChecklistSaveInstance");
                    Utilities_1.synUtil.beginAjaxProgress(buttonId);
                    Utilities_1.synUtil.getAJAXData({
                        method: "PUT",
                        url: checklistInstanceUrl,
                        requestData: {
                            instance: JSON.stringify(checklistInstance),
                            id: instId,
                            checkin: close,
                            fromDesigner: designer != undefined && designer != undefined,
                            haschanged: changed,
                            typeid: typeId,
                            action,
                        },
                        done(data) {
                            Utilities_1.synUtil.endAjaxProgress(buttonId);
                            saveCallback(data);
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            Utilities_1.synUtil.endAjaxProgress(buttonId);
                            Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                            saveObject === null || saveObject === void 0 ? void 0 : saveObject.fail();
                        },
                        cleanUp() {
                            saveObject === null || saveObject === void 0 ? void 0 : saveObject.cleanUp();
                        }
                    });
                }
                else {
                    if (close) {
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("InstanceUndoCheckOut") + instId,
                            cleanUp() {
                                saveCallback(undefined);
                                saveObject === null || saveObject === void 0 ? void 0 : saveObject.cleanUp();
                            }
                        });
                    }
                    else {
                        saveCallback(undefined);
                        saveObject === null || saveObject === void 0 ? void 0 : saveObject.cleanUp();
                    }
                }
            });
        }
    };
    $.fn.synChecklist = function (method) {
        if (methods[method])
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        else if (typeof method === 'object' || !method)
            return methods.init.apply(this, arguments);
        else
            $.error('Method ' + method + ' does not exist on jQuery.synChecklist');
    };
    function InitControls($this, checklist, configData, mode, readonly, action) {
        let synData = $this.data('synChecklist');
        if (!synData)
            return;
        require.ensure(["../../less/Checklist.less"], function (require) {
            let checklistLess = require("../../less/Checklist.less");
            let fac = new ChecklistControls_1.ClControlFactory($this, checklist, configData, mode, readonly, action);
            synData.controlFactory = fac;
            synData.controls = fac.create();
        });
    }
    function ShowDesigner($this, configData, checklist, mode, window, calledFromFatClient, action = ChecklistControls_1.ChecklistAction.New) {
        let synData = $this.data('synChecklist');
        if (!synData)
            return;
        require.ensure(["../../less/Checklist.less"], function (require) {
            let checklistLess = require("../../less/Checklist.less");
            let fac = new ChecklistControls_1.ClControlFactory($this, checklist, undefined, mode, false, action);
            let designer = new ChecklistDesigner_1.ClDesigner(fac, checklist);
            synData.checklistDesigner = designer;
            synData.controls = designer.create(configData, window, calledFromFatClient);
        });
    }
})(jQuery);
